export const data = [
    {
        number:"01",
        desc:"UBI Partnered with a top global pharma company for to optimize warehouse and Data-driven insights.",
        text:"BFSI",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/ERw26taXYi1BuBMUg6pG0rsBeycPmhehC1XWTIfXZ9PjaA?e=fivXvJ",
        radius: '7px 7px 0px 0px'
      },
      {
        number:"02",
        desc:"Unlocking wealth potential: Data driven insights for effective wealth management.",
        text:"Life Sciences",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/EVg-U9-BK2NGt5RalQtMqasBO87y94D3p_ACShWX5lT-tQ?e=6xz5fX",
        radius: '0px 0px 0px 0px'
      },
      {
        number:"03",
        desc:"Unleashing insights with UsefulBI: Data-driven in insurance-Enhancing customer satisfaction and claims manangement.",
        text:"Life Sciences",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/Eb6DLTmydS9OrN-1hHhGwSMBGdRmWWlJAP7G8n6hiZFhEw?e=HY3xAs",
        radius: '0px 0px 0px 0px'
      },
      {
        number:"04",
        desc:"Driving smarter decisions:Credit risk management and analysis is an evolving economy with UsefulBI",
        text:"Retail & CPG.",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/EUStImFPL8JLvq3MBKmlUbwB1CZor3KNJXpaa79_M9Jczw?e=PYMikB",
        radius: '0px 0px 0px 0px'
      },
      {
        number:"05",
        desc:"UBI Partnered with one of the Top 20 Global Pharma companies for Descriptive Analytics on Oncology Trials from Clinicaltrials.gov",
        text:"Life Sciences",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/EdHqvFuU3FBNvGqpei82LtcBZz4l9xp4mj1f0FS-gXQuZA?e=OSn9fK",
        radius: '0px 0px 0px 0px'
      },
      {
        number:"06",
        desc:"UBI partnered with a successful fortune 500 company to analyse its customer engagement and experience.",
        text:"BFSI",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/EfeP6diGXJxHgRZcnXaj1o8BwptHIC2UAIcE24wGbduhOQ?e=pSnNo7",
        radius: '0px 0px 0px 0px'
      },
      {
        number:"07",
        desc:"Leading Pharma companies want to understandthe flow of researh Grants and payments for regulatory compilance and to glean competitive intelligence.",
        text:"Life Sciences",
        link:"https://usefulbicorp.sharepoint.com/:v:/s/UBIDemoWebsite/EXqPpMA017NHo6ptJyY3UBQBpDuybDJzZa1OEOhoVHLjHQ?e=fgjJwN",
        radius: '0px 0px 7px 7px'
      }

  ];